import { Divider } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { AppRoutings } from "utility/enums/app-routings";
import { Constants } from "utility/enums/constants";

export function AccountFooter() {
  // Page level local variables
  const navigate = useNavigate();

  // handle events
  const handleOpenTermsAndCondition = () => {
    navigate(AppRoutings.TermsAndConditions);
  };
  return (
    <>
      <div className="login-links">
        <Tooltip title="Terms of Conditions">
          <a
            onClick={handleOpenTermsAndCondition}
            // href={
            //   Constants.TermsAndConditionPDFPath.toString() +
            //   "?v=" +
            //   new Date().getTime()
            // }
          >
            Terms of Conditions
          </a>
        </Tooltip>
        <Divider orientation="vertical" variant="middle" flexItem />
        <Tooltip title="Privacy Policy">
          <a href="https://doctorstoyou.com/privacy-policy/">Privacy Policy</a>
        </Tooltip>
      </div>
    </>
  );
}
